module.exports = __webpack_public_path__ + "img/member_center_footer431005.da7625e9.png";